import { useState } from "react";
import { CheckCircle, User, Mail, MessageSquare, Send } from "lucide-react";

export default function ContactSection() {
  const [formData, setFormData] = useState({ naam: "", email: "", bericht: "" });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const API = process.env.REACT_APP_BACKEND_URL;

  const validate = () => {
    const e = {};
    if (!formData.naam.trim()) e.naam = "Naam is verplicht";
    if (!formData.email.trim()) e.email = "E-mailadres is verplicht";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) e.email = "Voer een geldig e-mailadres in";
    if (!formData.bericht.trim()) e.bericht = "Bericht is verplicht";
    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const e2 = validate();
    if (Object.keys(e2).length > 0) { setErrors(e2); return; }
    setErrors({});
    try {
      const res = await fetch(`${API}/api/contact`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(formData) });
      if (!res.ok) throw new Error("Mislukt");
      setSubmitted(true);
    } catch { setErrors({ bericht: "Versturen mislukt. Probeer het opnieuw of mail direct naar info@fitsmith.nl" }); }
  };

  return (
    <section id="contact" data-testid="contact-section" className="py-20 lg:py-28 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="cta-banner mb-16">
          <div className="text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Klaar om te starten met jouw transformatie?</h2>
            <p className="text-zinc-300 text-base max-w-2xl mx-auto mb-8">Stop met uitstellen en investeer in jezelf. Kies vandaag nog jouw pakket.</p>
            <div className="flex flex-wrap gap-4 justify-center">
              <button onClick={() => document.querySelector("#aanbod")?.scrollIntoView({ behavior: "smooth" })}
                data-testid="cta-bekijk-pakketten" className="btn-gold px-8 py-3.5 font-bold text-sm uppercase tracking-wide">
                Bekijk alle pakketten
              </button>
              <button onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
                data-testid="cta-vraag-btn" className="btn-outline px-8 py-3.5 font-bold text-sm uppercase tracking-wide">
                Heb je een vraag?
              </button>
            </div>
          </div>
        </div>
        <div className="max-w-xl mx-auto">
          <div className="text-center mb-10">
            <p className="overline mb-2">Direct contact</p>
            <h3 className="text-2xl font-bold text-white">Stuur een bericht</h3>
          </div>
          {submitted ? (
            <div data-testid="form-success" className="form-success">
              <CheckCircle size={40} className="text-[#C9A84C] mx-auto mb-4" />
              <h4 className="text-white font-bold text-lg mb-2">Bericht verzonden!</h4>
              <p className="text-zinc-400 text-sm">We nemen zo snel mogelijk contact met je op.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} data-testid="contact-form" className="space-y-5">
              <div>
                <label className="form-label"><User size={14} /> Naam</label>
                <input type="text" value={formData.naam} onChange={e => setFormData({ ...formData, naam: e.target.value })}
                  data-testid="contact-naam" placeholder="Jouw naam" className={`form-input ${errors.naam ? "form-input-error" : ""}`} />
                {errors.naam && <p data-testid="error-naam" className="form-error">{errors.naam}</p>}
              </div>
              <div>
                <label className="form-label"><Mail size={14} /> E-mailadres</label>
                <input type="email" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })}
                  data-testid="contact-email" placeholder="jouw@email.com" className={`form-input ${errors.email ? "form-input-error" : ""}`} />
                {errors.email && <p data-testid="error-email" className="form-error">{errors.email}</p>}
              </div>
              <div>
                <label className="form-label"><MessageSquare size={14} /> Bericht</label>
                <textarea value={formData.bericht} onChange={e => setFormData({ ...formData, bericht: e.target.value })}
                  data-testid="contact-bericht" placeholder="Stel je vraag..." rows={5}
                  className={`form-input resize-none ${errors.bericht ? "form-input-error" : ""}`} />
                {errors.bericht && <p data-testid="error-bericht" className="form-error">{errors.bericht}</p>}
              </div>
              <button type="submit" data-testid="contact-submit-btn"
                className="btn-gold w-full py-3.5 font-bold text-sm uppercase tracking-wide flex items-center justify-center gap-2">
                <Send size={15} /> Verstuur bericht
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
